import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from '../constants';

export const SlipwayIcon = ({
  ariaLabel = 'Map waypoint icon for a slipway',
  ...props
}: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}

      <g clipPath="url(#clip0_187_17391)">
        <rect x="0.726562" width="32" height="32" rx="16" fill="#E9F8FF" />
        <path
          d="M16.7266 6.78125C20.5963 6.78125 23.7578 10.0269 23.7578 14.0608C23.7578 17.106 21.9774 19.9028 20.1268 21.9771C19.2083 23.0066 18.2885 23.8403 17.5981 24.4166C17.2532 24.7045 16.9664 24.9273 16.7669 25.0776C16.7545 25.0869 16.7424 25.096 16.7307 25.1047C16.718 25.0949 16.7049 25.0848 16.6913 25.0743C16.4914 24.9195 16.2043 24.6903 15.8591 24.3955C15.168 23.8052 14.2473 22.9547 13.3279 21.9136C11.4738 19.8138 9.69531 17.0175 9.69531 14.0608C9.69531 10.0269 12.8568 6.78125 16.7266 6.78125Z"
          fill="#1364BE"
          stroke="white"
          strokeWidth="0.9375"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.0823 11.186L15.5306 12.0453C15.5306 12.0453 12.8638 11.2407 12.8568 11.337C12.7363 12.9148 14.0218 14.0457 14.9798 14.4189C15.9377 14.7921 19.8732 16.2423 19.8732 16.2423L19.9861 16.2482C20.1023 16.2432 20.2127 16.193 20.2958 16.1063L21.2313 14.8089C21.2529 14.7887 21.2676 14.7617 21.2732 14.732C21.3349 14.5393 21.2482 14.3291 21.0718 14.2461L16.4157 12.3969L17.4253 11.8374C17.589 11.7331 17.6455 11.5122 17.5533 11.337C17.4611 11.1619 17.2531 11.0952 17.0823 11.186ZM20.6574 18.3232C21.0087 18.3232 21.0927 17.8331 20.7614 17.7161L13.0362 14.9874C12.8329 14.9155 12.6196 15.0664 12.6196 15.282V18.0107C12.6196 18.1833 12.7595 18.3232 12.9321 18.3232H20.6574Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_187_17391">
          <rect x="0.726562" width="32" height="32" rx="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
